<div id="DemoBadge" class="bg-secondary text-white">{{'This is a demo platform, please do not use it for real submissions.'|translate}}</div>